import { Box } from '@dtx-company/design-system/src'
import { DashboardDisplay } from './DashboardDisplay'
import { FC } from 'react'
import { Menu } from './seo-menu/components/menu'
import { MenuProvider } from './seo-menu/context'
import { NAV_V2_LOGGED_OUT_LINKS_BP } from '@dtx-company/true-common/src/constants/layout'
import { NavLinksProps } from './NavLinks.types'
import { RootCodeState } from '@dtx-company/inter-app/src/redux/types'
import { SignInOptions } from './SignInOptions'
import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'
import { useMarketingMenuData } from './seo-menu/hooks/use-marketing-menu-data'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'
import styled from 'styled-components'

const LinksWrapper = styled(Box)`
  justify-content: center;
  width: 100%;
  flex-grow: 1;
  @media (max-width: ${NAV_V2_LOGGED_OUT_LINKS_BP - 1}px) {
    display: none;
  }
`

export const MarketingNavLinks: FC<NavLinksProps> = ({ isLoggedIn, isFPHomepage = false }) => {
  const marketingMenuData = useMarketingMenuData()
  const { hideNavbarSignInOptions } = useCodeSelector((state: RootCodeState) => state.settings)

  const { isMobile } = useScreenSizeBreakpoints()

  return (
    <Box
      data-testid="marketing-nav-desktop"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        // logo width
        pr: hideNavbarSignInOptions ? '142px' : undefined,
        width: '100%'
      }}
    >
      <LinksWrapper>
        <MenuProvider>
          <Menu menuItems={marketingMenuData} />
        </MenuProvider>
      </LinksWrapper>

      {/* Auth/Dashboard buttons */}
      {isLoggedIn && !isMobile && <DashboardDisplay />}
      {!isLoggedIn && !hideNavbarSignInOptions && <SignInOptions isFPHomepage={isFPHomepage} />}
    </Box>
  )
}
